import { CALL_DINAMIC_DISABLE_LOTE, CLOSE_MODALES, CLOSE_MODAL_ANEXOS, DATA_ANULATION_FORM, DATA_MODAL_DESCARGAR_DATOS, ERROR_GENERAL, GESTIONA_MODAL_TRY_CATCH, INIT_OPEN_COMPONENT_REPORTS, LOAD_DOCUMENT_SUCCESS, MESSAGES_ALERT_PARAMETRIZADOS, MESSAGE_ALERT_SEND, MESSAGE_ANULATION_FORM_RYA, MESSAGE_CONFIRMATION_SEND, OCULTAR_DEVOLUCIONES, OCULTAR_DE_ANULACIONES, OPEN_ANULATION_FORM, OPEN_COMPONENT_INFORMES, OPEN_FORM_BANDEJA, OPEN_HISTORIAL_BANDEJA, OPEN_MODAL_CHARGED, RETURN_HOME_BANDEJA, SAVED_INFO_USER_BANDEJA, SAVE_CONSULTA_REPORTS, SEND_MESSAGE_CONFIRMATION_RYA, SET_DATA_PAGINAR_REG_EMPRESAS, SET_DATA_PAGINAR_REPORTS_EMPRESAS, TYPE_USER_BANDEJA, UPDATE_MSG_SOLICITUD, VALIDATE_USER_TYPE, VALIDATE_USER_TYPE_SUCCESS, VISUALIZE_ANEXOS } from './constants';

export const initialState = {
    errorTryCatch: false,
    dataRegCompany: [],
    consultaPaginada: false,
    dataReportsCompany: [],
    totalConsultaReports: false,
    consultaPaginadaReports: false,
    openFormBandeja: false,
    idFormulario: false,
    openSeeAnexos: false,
    ocultaDevoluciones: false,
    nameButtonDev: "Devolver",
    messageConfirmation: false,
    messageConfirmationRya: false,
    openModalCharged: false,
    dynamicOptions: false,
    messageAlert: false,
    messageAnulationRya:false,
    messageHistory: false,
    sessionValidated: false,
    msgParametrizados: MESSAGES_ALERT_PARAMETRIZADOS,
    userInfo: false,
    userType: "comercial",
    idUsuaAsesor: false,
    suc_id: "",
    historyBandeja: false,
    dynamicDisable: {},
    showSnackBar: false,
    dataModalDatos: false,
    consultaReports: false,
    openMondalTryCatch: false,
    dataAnulationForm: false,
    openAnulationForm: false,
    
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    const { payload, type, value } = action;
    // newState.errorTryCatch = false;

    switch (type) {

        case SET_DATA_PAGINAR_REG_EMPRESAS:

            if (payload.esPrimeraPagina) {
                newState.dataRegCompany = payload.dataRegCompany;
            } else {
                newState.dataRegCompany = payload.dataPaginada;
            }
            newState.consultaPaginada = true;

            return { ...newState };

        case SET_DATA_PAGINAR_REPORTS_EMPRESAS:
            console.log(payload)
            if (payload.esPrimeraPagina) {
                newState.dataReportsCompany = payload.dataReportsCompany;
            } else {
                newState.dataReportsCompany = payload.dataPaginada;
            }
            if (payload.totalConsulta) {
                newState.totalConsultaReports = payload.totalConsulta;
            } else {
                newState.totalConsultaReports = 0;
            }
            newState.consultaPaginadaReports = true;

            return { ...newState };

        case ERROR_GENERAL:
            newState.openModalCharged = false;
            newState.errorTryCatch = payload;
            newState.openMondalTryCatch = true;
            return { ...newState }

        case GESTIONA_MODAL_TRY_CATCH:
            newState.openMondalTryCatch = false;
            return { ...newState }

        case UPDATE_MSG_SOLICITUD:
            let pos = null;
            newState.msgParametrizados.map((e, index) => {
                if (e.value === payload.id) {
                    pos = index;
                }
            });

            if (pos !== null) {
                newState.msgParametrizados[pos].label = payload.text;
                newState.msgParametrizados[pos].download = payload.download;
            }
            return { ...newState }

        case OPEN_FORM_BANDEJA:
            newState.openFormBandeja = payload.state;
            newState.idFormulario = payload.idForm;
            return { ...newState };

        case RETURN_HOME_BANDEJA:
            newState.openFormBandeja = false;
            newState.idFormulario = false;
            newState.messageConfirmation = false;
            newState.messageConfirmationRya = false;
            newState.messageAlert = false;
            newState.messageHistory = false;
            newState.openSeeAnexos = false;
            newState.openInformes = false;
            newState.messageAnulationRya = false;

            return { ...newState };

        case INIT_OPEN_COMPONENT_REPORTS:
            newState.openInformes = true;

            return { ...newState };

        case OCULTAR_DEVOLUCIONES:
            newState.ocultaDevoluciones = true;
            newState.nameButtonDev = "Anular";
            return { ...newState };

        case DATA_ANULATION_FORM:
            newState.dataAnulationForm = payload;
            return { ...newState };

        case OPEN_ANULATION_FORM:
            console.log(action)
            if (payload) {
                newState.openAnulationForm = false;
                newState.dataAnulationForm = false;
            } else {
                if (value === "closed") {
                    newState.openAnulationForm = false;
                    newState.dataAnulationForm = false;
                } else
                    newState.openAnulationForm = true;
            }
            return { ...newState };

        case OCULTAR_DE_ANULACIONES:
            newState.ocultaDevoluciones = false;
            newState.nameButtonDev = "Devolver";
            return { ...newState };

        case VISUALIZE_ANEXOS:
            newState.openSeeAnexos = value.row;
            return { ...newState };

        case CLOSE_MODAL_ANEXOS:
            newState.openSeeAnexos = false;
            return { ...newState };

        case MESSAGE_CONFIRMATION_SEND:
            newState.messageConfirmation = payload;
            return { ...newState };

        case SEND_MESSAGE_CONFIRMATION_RYA:
            newState.messageConfirmationRya = payload;
            return { ...newState };

        case OPEN_MODAL_CHARGED:
            newState.openModalCharged = payload;
            return { ...newState }


        case CALL_DINAMIC_DISABLE_LOTE:
            payload.map(e => {
                newState.dynamicDisable[e.field] = e.state;
            });
            newState.showSnackBar = !newState.showSnackBar;
            return { ...newState };

        case LOAD_DOCUMENT_SUCCESS:
            newState.dynamicOptions = payload;
            return { ...newState };

        case SAVE_CONSULTA_REPORTS:
            newState.consultaReports = payload;
            return { ...newState };

        case MESSAGE_ALERT_SEND:
            newState.messageAlert = payload;
            return { ...newState };

        case MESSAGE_ANULATION_FORM_RYA:
            newState.messageAnulationRya = payload;
            return { ...newState };

        case VALIDATE_USER_TYPE_SUCCESS:
            newState.sessionValidated = payload;
            return { ...newState };

        case SAVED_INFO_USER_BANDEJA:
            newState.userInfo = payload;
            newState.sessionValidated = true;
            return { ...newState };

        case TYPE_USER_BANDEJA:
            newState.userType = payload.rol;
            newState.suc_id = payload.suc_id;
            newState.idUsuaAsesor = payload.idUsuaAsesor;
            return { ...newState };

        case OPEN_HISTORIAL_BANDEJA:
            newState.messageHistory = true;
            newState.historyBandeja = payload;
            return { ...newState };

        case DATA_MODAL_DESCARGAR_DATOS:
            newState.dataModalDatos = payload;
            return { ...newState };

        case CLOSE_MODALES:
            newState.dataModalDatos = false;
            newState.messageAlert = false;
            newState.messageConfirmation = false;
            newState.messageConfirmationRya = false;
            newState.messageHistory = false;
            newState.messageAnulationRya = false;

            return { ...newState };

        default:
            return {
                ...newState
            };
    }
}

export default reducer;